import React, { useContext } from 'react';
import * as S from './styled';
import {
  documentsCongratulationsTitle,
  documentsCongratulationsSubTitle,
  documentsProposalNumberLabel,
  documentsProductLabel,
  documentsProductButtonText,
  ibcDocumentsProductButtonText,
} from '../../utils/constants';
import { Row } from '../../styles/utils/Grid';
import CongratulationsTitle from '../CongratulationsTitle';
import { AppContext } from '../../context';
import env from '../../config/environment';

const Congratulations = ({ orderNum }) => {
  const { ibcLogged } = useContext(AppContext);
  const handleClick = () => {
    if (ibcLogged) {
      window.open(env.IBC_URL, '_blank');
    } else {
      window.location.href = env.AREA_LOGADA_LOGIN;
    }
  };
  return (
    <S.CongratsSection noPadding>
      <CongratulationsTitle
        title={documentsCongratulationsTitle}
        subtitle={documentsCongratulationsSubTitle}
        flex
      />
      <Row columns={2}>
        <S.ProposalTitledContent
          title={documentsProposalNumberLabel}
          content={orderNum}
          flex
        />
        <S.ProductTitledContent
          title={documentsProductLabel}
          onClick={handleClick}
          component
          content={
            <S.ProductButton bold inverse>
              {ibcLogged
                ? ibcDocumentsProductButtonText
                : documentsProductButtonText}
            </S.ProductButton>
          }
          flex
        />
      </Row>
    </S.CongratsSection>
  );
};

export default Congratulations;
